export enum SurveyStatus {
    NotAnswered = 0,
    Answered = 1
}

export enum FeedbackStatus {
    Ongoing = 0,
    ChatbaseInProgress = 5,
    ChatbaseCompleted = 10,
    Completed = 100
}

export enum SurveyQuestionType {
    FreeText = 10,
    Rating = 20,
    SingleSelection = 30,
    MultipleSelection = 40,
}

export enum CodeType {
    qrCode=1,
    Webcode=2
}

export enum CampaignType {
	full = 1,
	feedbackOnly = 2,
	brandLoopOnly = 3,
}